export const ENTER_CODE_SYMBOLS_COUNT = 6;
